/**
 * This file is auto-generated from ChatInputAttachment.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const remove: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Remove attachment';
        case 'pl':
            return 'Usuń załącznik';
    }
};
